// @ts-nocheck
import React, { useState } from 'react'
import { useRouter } from 'next/router'
import { useSession, signIn, signOut } from 'next-auth/react'
import Script from 'next/script'
import { Container, Button } from 'react-bootstrap'

import Error from '@components/error'
import Loading from '@components/loading'
import NavBar from '@components/navbar'
import PushNotifications from '@components/notifications/push';
import ValeuFloatingButton from '@components/valeu/floating-button'
import Footer from '@components/footer'
import ButtonLink from '@components/text/button-link'
import { getEnvironment, getConstant, isDeveloping, getVersion, NEXT_PUBLIC_REMOVE_FEATURE_VALEU } from '@utils/constants'
import { hasAccessTo } from '@utils/groups'

export default function AdminLayout({ auth = true, groups = null, container = null, children }) {
  const router = useRouter();
  const [shouldLogin, setShouldLogin] = useState(false);

  const isValeuPage = router.pathname.startsWith('/valeu');
  const isHomePage = router.pathname === '/';

  const { data: session, status } = useSession({
    required: auth,
    onUnauthenticated() {
      setShouldLogin(true);
    }
  });

  const authenticate = () => {
    signIn('azure-ad');
  };

  const reauthenticate = () => {
    signOut({ redirect: false });
    signIn('azure-ad');
  };

  if (! auth) {
    return <>{children}</>;
  }

  if (status === 'loading' && ! shouldLogin) {
    return <Loading size="xl" text="Carregando" mode="fullscreen" />;
  }

  if (! session?.user || shouldLogin) {
    return (
      <div className="login-page">
        <div className="login-logo">
          <img src="/images/logo.png" height={28} width={168} alt={getConstant('sitename')} />
        </div>
        <Error className="login-form" title="Intranet" message="Faça login com a conta da Fortesec para continuar.">
          <Button className="px-5 py-2" onClick={ authenticate }>ENTRAR</Button>
        </Error>
        <p className="footer-version text-center">
          Versão { getVersion() }
        </p>
        <div id="main-background" />
      </div>
    );
  }

  if (! hasAccessTo(session?.user, groups)) {
    return (
      <Error message="Você não tem permissão para acessar essa página.">
        <Button onClick={reauthenticate}>
          ENTRAR NOVAMENTE
        </Button>
      </Error>
    );
  }

  return (
    <div className="d-flex flex-column h-full main-app">
      <PushNotifications user={session.user} />
      <NavBar user={session.user} />
      <Container className="py-5 flex-grow-1" {...(container || { fluid: false })}>
        { children }
      </Container>
      <Footer />
      { ! isValeuPage && ! isHomePage && NEXT_PUBLIC_REMOVE_FEATURE_VALEU !== '1' && <ValeuFloatingButton /> }
      <div id="main-background" />
      {getEnvironment() === 'local' && <Script id="development-userinfo">{`console.log('USER:', ${JSON.stringify(session.user)})`}</Script>}
    </div>
  );
}
